/* Pagination des carrousels mobiles de la page About (← n/N →).
   Délégation sur document : insensible au moment où le script est exécuté
   et aux sections rechargées par l'éditeur de thème.
   Le drapeau évite le double branchement quand deux sections chargent le fichier. */
(function () {
  if (window.__ajpCarrousel) return;
  window.__ajpCarrousel = true;

  function piste(pager) {
    return document.getElementById(pager.getAttribute('data-cible'));
  }

  /* Largeur d'une vignette, gouttière comprise. */
  function pas(p) {
    var c = p.children;
    if (c.length < 2) return p.clientWidth;
    return c[1].getBoundingClientRect().left - c[0].getBoundingClientRect().left;
  }

  function maj(pager) {
    var p = piste(pager);
    if (!p) return;
    var n = pager.querySelector('[data-index]');
    var u = pas(p);
    if (!n || !u) return;
    n.textContent = Math.max(1, Math.min(p.children.length, Math.round(p.scrollLeft / u) + 1));
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var b = e.target.closest('.ajp-pager [data-pas]');
    if (!b) return;
    var pager = b.closest('.ajp-pager');
    var p = pager && piste(pager);
    if (!p) return;
    p.scrollBy({ left: pas(p) * parseInt(b.getAttribute('data-pas'), 10), behavior: 'smooth' });
  });

  /* Les événements scroll ne remontent pas : on écoute en phase de capture. */
  document.addEventListener('scroll', function (e) {
    var p = e.target;
    if (!p || !p.id || p.id.indexOf('ajp-piste-') !== 0) return;
    clearTimeout(p.__ajpT);
    p.__ajpT = setTimeout(function () {
      var pager = document.querySelector('.ajp-pager[data-cible="' + p.id + '"]');
      if (pager) maj(pager);
    }, 90);
  }, true);
})();
